import { Box } from "@mui/material";
import * as React from "react";
import OlivePC from "../../../assets/images/olive.png";
import { PageContent } from "../page-content.emotion";
import Steam from "../../../assets/images/steamLogo.png";
import Itch from "../../../assets/images/itchio_badge.png";
import { ItchLink } from "../home-page/home-page.emotion";
import LongCard from "../../long-card/long-card";

export default function OlivePCPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageContent>
        <Box mt={10} mr={7} ml={7}>
          <LongCard image={OlivePC} title="Olive">
            <p>
              Play as Olive, a sprightly old lady, to collect gems and
              progressively fill the scene with colour in this arcade runner
              style game. Grow plants with the coins you collect, unlock new
              abilities, and collect outfits to customise your look.
            </p>
            <Box mt={1} mb={1}>
              <a
                href="https://store.steampowered.com/app/2831870/Olive/"
                target="_blank"
              >
                <img src={Steam} width={120} />
              </a>
              <ItchLink
                href="https://dustinhollis.itch.io/olive"
                target="_blank"
              >
                <img src={Itch} width={120} />
              </ItchLink>
            </Box>
          </LongCard>
        </Box>
      </PageContent>
    </>
  );
}
